import {useTranslation} from '@/translations/i18n'
import {routes} from '@/utilities/constants/routes'
import {DetailsPageContentTabWrapper} from '@/components/ui/details-atoms/DetailsAtoms'
import {Tab, Tabs} from '@/components/ui/tab-atoms/TabAtoms'

export const DashboardTabs = () => {
    const {t} = useTranslation()

    const tabs = [
        {
            label: t('dashboard:operational'),
            path: routes.DASHBOARD_OPERATIONAL.handle.path
        },
        {
            label: t('dashboard:consultant'),
            path: routes.DASHBOARD_CONSULTANT.handle.path
        },
        {
            label: t('dashboard:economic'),
            path: routes.DASHBOARD_ECONOMIC.handle.path
        }
    ] as const satisfies Array<{label: string; path: string}>

    return (
        <DetailsPageContentTabWrapper style={{width: '100%'}}>
            <Tabs paddingX={4}>
                {tabs.map(tab => (
                    <Tab key={tab.path} to={tab.path}>
                        {tab.label}
                    </Tab>
                ))}
            </Tabs>
        </DetailsPageContentTabWrapper>
    )
}
